import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const UpdateIcon = () => {
  return (
    <motion.span
      className="update-icon"
      animate={{ rotate: [0, 360] }}
      transition={{
        ease: "linear",
        times: [0, 1],
        duration: 6,
        repeat: Infinity,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="top_arrow">
          <path
            className="cls-3"
            d="M41.3,2.46v6.16h-6.16v-1.93h2.4C31.55,1.9,23.6.61,16.24,3.37c-2.77,1.04-5.25,2.59-7.34,4.55-2.09,1.96-3.8,4.34-5.01,7.03-2.42,5.35-2.62,11.33-.55,16.83.78,2.06,1.85,3.99,3.18,5.72l-1.52,1.18c-1.45-1.88-2.61-3.97-3.45-6.22C-.7,26.48-.49,19.97,2.14,14.15,4.78,8.29,9.55,3.82,15.57,1.56,23.83-1.55,32.8.06,39.38,5.72v-3.26h1.92Z"
          />
        </g>
        <motion.g
          animate={{ rotate: [0, -360] }}
          transition={{
            ease: "linear",
            times: [0, 1],
            duration: 6,
            repeat: Infinity,
          }}
        >
          <g id="circle">
            <circle className="cls-4" cx="23.88" cy="23.9" r="17.6" />
          </g>
          <g id="zero_1">
            <motion.path
              className="cls-2"
              d="M16.45,23.24h-.29c-1.46,0-2.64-1.19-2.64-2.65v-3.06c0-1.46,1.18-2.65,2.64-2.65h.29c1.46,0,2.64,1.19,2.64,2.65v3.06c0,1.46-1.18,2.65-2.64,2.65ZM16.16,16.31c-.66,0-1.2.54-1.2,1.21v3.06c0,.66.54,1.21,1.2,1.21h.29c.66,0,1.2-.54,1.2-1.21v-3.06c0-.66-.54-1.21-1.2-1.21h-.29Z"
              animate={{ opacity: [1, 1, 0, 1, 1] }}
              transition={{
                ease: "linear",
                times: [0, 0.16, 0.17, 0.18, 1],
                duration: 6,
                repeat: Infinity,
              }}
            />
          </g>
          <g id="one_1">
            <path
              className="cls-2"
              d="M23.88,23.24c-.4,0-.72-.32-.72-.72v-6.92c0-.4.32-.72.72-.72s.72.32.72.72v6.92c0,.4-.32.72-.72.72Z"
            />
          </g>
          <g id="zero_2">
            <path
              className="cls-2"
              d="M31.61,23.24h-.29c-1.46,0-2.64-1.19-2.64-2.65v-3.06c0-1.46,1.18-2.65,2.64-2.65h.29c1.46,0,2.64,1.19,2.64,2.65v3.06c0,1.46-1.18,2.65-2.64,2.65ZM31.31,16.31c-.66,0-1.2.54-1.2,1.21v3.06c0,.66.54,1.21,1.2,1.21h.29c.66,0,1.2-.54,1.2-1.21v-3.06c0-.66-.54-1.21-1.2-1.21h-.29Z"
            />
          </g>
          <g id="one_2">
            <motion.path
              className="cls-2"
              d="M16.31,32.93c-.4,0-.72-.32-.72-.72v-6.92c0-.4.32-.72.72-.72s.72.32.72.72v6.92c0,.4-.32.72-.72.72Z"
              animate={{ opacity: [1, 1, 0, 1, 1] }}
              transition={{
                ease: "linear",
                times: [0, 0.66, 0.67, 0.68, 1],
                duration: 6,
                repeat: Infinity,
              }}
            />
          </g>
          <g id="zero_3">
            <path
              className="cls-2"
              d="M24.03,32.93h-.29c-1.46,0-2.64-1.19-2.64-2.65v-3.06c0-1.46,1.18-2.65,2.64-2.65h.29c1.46,0,2.64,1.19,2.64,2.65v3.06c0,1.46-1.18,2.65-2.64,2.65ZM23.74,26.01c-.66,0-1.2.54-1.2,1.21v3.06c0,.66.54,1.21,1.2,1.21h.29c.66,0,1.2-.54,1.2-1.21v-3.06c0-.66-.54-1.21-1.2-1.21h-.29Z"
            />
          </g>
          <g id="zero_4">
            <motion.path
              className="cls-2"
              d="M31.61,32.93h-.29c-1.46,0-2.64-1.19-2.64-2.65v-3.06c0-1.46,1.18-2.65,2.64-2.65h.29c1.46,0,2.64,1.19,2.64,2.65v3.06c0,1.46-1.18,2.65-2.64,2.65ZM31.31,26.01c-.66,0-1.2.54-1.2,1.21v3.06c0,.66.54,1.21,1.2,1.21h.29c.66,0,1.2-.54,1.2-1.21v-3.06c0-.66-.54-1.21-1.2-1.21h-.29Z"
              animate={{ opacity: [1, 1, 0, 1, 1] }}
              transition={{
                ease: "linear",
                times: [0, 0.49, 0.5, 0.51, 1],
                duration: 6,
                repeat: Infinity,
              }}
            />
          </g>
        </motion.g>
        <g id="bottom_arrow">
          <path
            className="cls-1"
            d="M45.86,33.85c-2.64,5.86-7.41,10.33-13.43,12.59-2.79,1.05-5.66,1.56-8.49,1.56-5.55,0-10.96-1.97-15.32-5.72v3.26h-1.92v-6.16h6.16v1.93h-2.4c5.99,4.79,13.94,6.08,21.3,3.32,2.77-1.04,5.25-2.59,7.34-4.55,2.09-1.96,3.8-4.34,5.01-7.03,2.42-5.35,2.62-11.33.55-16.83-.78-2.07-1.85-3.99-3.18-5.72l1.52-1.18c1.45,1.88,2.61,3.97,3.45,6.22,2.25,5.98,2.04,12.49-.59,18.31Z"
          />
        </g>
      </svg>
    </motion.span>
  )
}

export default UpdateIcon
